import { Event } from '@sentry/types/types';

const SENTRY_IGNORE_WARNING_FILTER: RegExp[] = [/Missing "offer_id" or "transaction_id"/];
export default function suppressWarnings(event: Event): boolean {
  if (event.level !== 'warning') return false;

  return SENTRY_IGNORE_WARNING_FILTER.some((regexp) => regexp.test(event.message || ''));
}
